import { iconsData, specialIcons } from '../../core/pixi/icons';
import { applicationStore } from '../../store/applicationStore';

export class SpinIconNumberProvider {
  constructor(index) {
    this.fullSet = Object.keys(iconsData).filter((num) => {
      if (+num === 9 && (index === 0 || index === 4)) {
        return false;
      }
      if (+num === 11 && (index === 1 || index === 3)) {
        return false;
      }
      if (+num === 400) {
        return false;
      }
      return num;
    });
    this.lastIcon = null;
    this.buyBonusState = false;
  }

  getNext(columnNumber) {
    const set = this.fullSet.filter(
      (i) =>
        i !== this.lastIcon &&
        (columnNumber !== 1 || (columnNumber !== 3 && i !== specialIcons.scatter))
    );
    this.lastIcon = set[Math.floor(Math.random() * set.length)];
    return this.lastIcon;
  }
}
